import React from 'react';

const Icon = ({ width = '50', height = '49', fill = '#EEFFED', ...other }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 50 49" fill="none" {...other}>
            <rect x="5.465" y="12.666" width="31.792" height="21.195" rx="2.271" stroke="black" strokeWidth="2.271" />

            <path
                d="M10.007 29.318V18.721c0-.836.678-1.514 1.514-1.514h1.514c.836 0 1.514.678 1.514 1.514v9.083c0 .836.678 1.514 1.514 1.514h1.514c.836 0 1.513-.678 1.513-1.514v-9.083c0-.836.678-1.514 1.514-1.514h1.514c.836 0 1.514.678 1.514 1.514v9.083c0 .836.678 1.514 1.514 1.514h1.514c.836 0 1.514-.678 1.514-1.514v-9.083c0-.836.678-1.514 1.514-1.514h1.514c.836 0 1.513.678 1.513 1.514v10.597"
                stroke="black"
                strokeWidth="2.271"
                strokeLinecap="round"
            />

            <path d="M11.521 32.952v3.937c0 .836.678 1.513 1.514 1.513h28.007c.836 0 1.514-.677 1.514-1.514v-12.11" stroke="black" strokeWidth="2.271" />

            <rect x="39.528" y="13.423" width="6.056" height="10.597" rx="0.757" fill="black" stroke="black" strokeWidth="1.514" />

            <path d="M43.691 16.829a1.135 1.135 0 1 1-2.27 0 1.135 1.135 0 0 1 2.27 0Z" fill={fill} />

            <circle cx="42.556" cy="20.991" r="0.757" fill={fill} />
        </svg>
    );
};
export default React.memo(Icon);
